import { Component, Input } from '@angular/core';

/**
 * Header padrão das páginas da administração global — ícone + título no estilo
 * da "Lista de submissões" do TPC chair (reusa as classes globais
 * `.main-title` / `.main-title-icon` / `h1` de `_header.scss`). Controles
 * opcionais (busca, botões, filtros) são projetados à direita via `<ng-content>`.
 *
 * As cores de título/ícone são replicadas no SCSS porque a regra global de cor
 * é escopada a `.main-header .main-title` e não casa com este header próprio.
 */
@Component({
  selector: 'app-admin-page-header',
  templateUrl: './admin-page-header.component.html',
  styleUrls: ['./admin-page-header.component.scss']
})
export class AdminPageHeaderComponent {
  /** Material Symbols Outlined — nome como conteúdo do `<mat-icon>`. */
  @Input() icon: string;
  /** Chave i18n do título da página. */
  @Input() titleKey: string;
}
